<template>
    <div class="liga">
        <Navbar showBackButton></Navbar>

        <div class="poveznice">
            <Poveznice></Poveznice>
        </div>

        <div class="container" v-if="!loaded">
            Učitavanje
        </div>

        <transition name="fade-translate" appear>
            <div class="container" v-if="loaded">
                <PanelPokreni v-if="appState == 'round-in-progress'"/>

                <h2 class="league-title">Moja liga</h2>
                <div class="liga-card-wrapper">
                    <LigaSingle :ligaId="userData.vlasnikLige" v-if="userData.vlasnikLige"></LigaSingle>
                    <NoResults v-if="!userData.vlasnikLige">
                        <template v-slot:error-content>
                            <p class="text">Niste vlasnik/ca niti jedne lige, kreirajte svoju ligu
                                <router-link to="/kreiraj-ligu">ovdje</router-link>
                                i natječite se sa svojim prijateljima
                            </p>
                        </template>
                    </NoResults>
                </div>
            </div>
        </transition>

        <transition name="fade-translate">
            <div class="container" v-if="loaded && notOwnLeauges && notOwnLeauges.length > 0">
                <h2 class="league-title">Lige u kojima sudjelujem</h2>
                <div class="liga-card-wrapper">
                    <LigaSingle :ligaId="ligaId" v-for="ligaId in notOwnLeauges" v-bind:key="ligaId"></LigaSingle>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Poveznice from '../components/Poveznice.vue'
import LigaSingle from '../components/liga/LigaSingle'
import NoResults from '../components/common/error/NoResults'
import PanelPokreni from '../components/PanelPokreni'
// TODO: Testiranje
// case 1: ja sam u 1 ligi i nisam vlasnik ni jedne
// case 2: ja sam u 2 lige i vlasnik sam jedne od te dvije
// case 3: ja sam u 1 ligi i vlasnik sam te lige
export default {
    name: 'liga1',
    data: function () {
        return {
            inLeauges: false
        }
    },
    components: {
        Navbar,
        Poveznice,
        LigaSingle,
        NoResults,
        PanelPokreni
    },
    async mounted () {
        const data = await this.$db.lige.getAllMyLeaugeIds(this.uid)
        if (data) {
            this.inLeauges = data
        }
    },
    computed: {
        loaded () {
            try {
                return !!(this.metadata.loaded && this.userData)
            } catch (error) {
                return false
            }
        },
        metadata () {
            try {
                return this.$store.state.metadata
            } catch (error) {
                return false
            }
        },
        uid () {
            try {
                return this.$store.state.user.uid
            } catch (error) {
                return false
            }
        },
        userData () {
            try {
                return this.metadata.userData
            } catch (error) {
                return false
            }
        },
        notOwnLeauges () {
            if (this.userData.vlasnikLige && this.inLeauges) {
                return this.inLeauges.filter(elem => elem !== this.userData.vlasnikLige)
            } else if (this.inLeauges && this.userData.vlasnikLige === undefined) {
                return this.inLeauges
            }
            return []
        },
        appState () {
            return this.$store.state.appState
        }
    }
}
</script>

<style lang="scss" scoped>
.liga {
    padding-top: 22px;
    .poveznice {
        margin-bottom: 30px;
    }
    .container {
        *:not(.panel-pokreni) {
            text-align: left;
        }
        padding-bottom: 30px;
    }
    .panel-pokreni {
        margin-bottom: 30px;
    }
}

@media only screen and (min-width: 800px) {
    .liga {
        max-width: 1280px;
        margin: auto;
    }
}
</style>
